import { render, staticRenderFns } from "./ReContactAtopicDermatitis.vue?vue&type=template&id=2114075f&lang=pug&"
import script from "./ReContactAtopicDermatitis.vue?vue&type=script&lang=js&"
export * from "./ReContactAtopicDermatitis.vue?vue&type=script&lang=js&"
import style0 from "./ReContactAtopicDermatitis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports